module.exports = __webpack_public_path__ + "static/media/portada.508ec5e2.svg";